import type { StarTrack } from '@/app/common/starTrack/startrack.ts';
import { ampliProductSelected } from '@/app/common/amplitude/events/ampliProductSelected.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider.tsx';
import type { SearchParams } from '@/server/searchParams.ts';
import type { OffersData } from '@/app/components/hotel-detail/OffersProvider.tsx';
import type { Localization } from '@/app/components/search/common/Localization';
import { createDetailBookClickedPayload } from '@/app/common/starTrack/events/detailBookClicked.ts';

type TrackingProductSelectedProps = {
  starTrack: StarTrack;
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  commonData: CommonData;
  localization: Localization;
  initialParams: InitialParams;
  offersData: OffersData | undefined;
  actionId: string;
  selectedMealPlan: MealPlanType;
  roomId: string;
  /** Overrides initialParams.flightClickId when the id is generated in the same click
   *  (the provider state update is not readable yet) — see useTrackEvoBookClicked. */
  flightClickId?: string;
};
export const trackingProductSelected = ({
  starTrack,
  searchParams,
  searchInfoData,
  commonData,
  localization,
  initialParams,
  offersData,
  actionId,
  selectedMealPlan,
  roomId,
  flightClickId,
}: TrackingProductSelectedProps) => {
  starTrack.detailBookClicked(
    createDetailBookClickedPayload({
      searchParams,
      searchInfoData,
      initialParams,
      offersData,
      actionId,
      selectedMealPlan,
      roomId,
      flightClickId,
    })
  );

  ampliProductSelected({ searchInfoData, commonData, localization, initialParams });
};
